import { Check, Clock, Play } from 'lucide-react';

/** Reusable status helpers + labor-cost calculator. Shared by the
 *  parent CleaningView and its extracted sub-components so the source
 *  of truth for status colors + labor math lives in one place. */

export const getStatusIcon = (status) => {
  switch (status) {
    case 'completed':
      return <Check className="h-4 w-4 text-emerald-600" />;
    case 'in_progress':
      return <Play className="h-4 w-4 text-blue-600" />;
    default:
      return <Clock className="h-4 w-4 text-amber-600" />;
  }
};

export const getStatusBadge = (status) => {
  switch (status) {
    case 'completed':
      return 'bg-emerald-50 text-emerald-700 border-emerald-200';
    case 'in_progress':
      return 'bg-blue-50 text-blue-700 border-blue-200';
    default:
      return 'bg-amber-50 text-amber-700 border-amber-200';
  }
};

export const calculateLaborCost = (task) => {
  if (!task?.hours_worked || !task?.hourly_rate) return 0;
  return task.hours_worked * task.hourly_rate;
};
